import React from 'react';
import PropTypes from 'prop-types';

import hoistNonReactStatics from 'hoist-non-react-statics';
import {reduxForm} from 'redux-form';

import ConstructedTextField from './fields/ConstructedTextField';
import ConstructedTextAreaField from './fields/ConstructedTextAreaField';
import ConstructedSelectField from './fields/ConstructedSelectField';
import ConstructedCheckboxGroupField from './fields/ConstructedCheckboxGroupField';
import ConstructedRadioGroupField from './fields/ConstructedRadioGroupField';
import Button from '../button/Button';
import PrimaryButton from '../button/PrimaryButton';
import {FormattedMessage} from 'react-intl';

const fieldComponentMap = {
  textfield: ConstructedTextField,
  textarea: ConstructedTextAreaField,
  select: ConstructedSelectField,
  checkboxes: ConstructedCheckboxGroupField,
  radios: ConstructedRadioGroupField
};

const extractInitialValues = WrappedComponent => hoistNonReactStatics(
  ({fields, ...rest}) => (
    <WrappedComponent
      fields={fields}
      initialValues={fields.reduce((acc, field) => {
        const FieldComponent = fieldComponentMap[field.type];

        if (FieldComponent) {
          acc[field.code] = field.value || FieldComponent.defaultValue || '';
        }

        return acc;
      }, {})}
      {...rest}
    />
  ),
  WrappedComponent
);

@extractInitialValues
@reduxForm({
  form: 'constructedForm'
})
export default class ConstructedForm extends React.PureComponent {
  static propTypes = {
    fields: PropTypes.arrayOf(PropTypes.shape({
      code: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      value: PropTypes.any,
      required: PropTypes.bool,
      choices: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        code: PropTypes.string.isRequired
      }))
    })).isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  render() {
    const {fields, handleSubmit, submitting, error} = this.props;

    return (
      <form className="form" onSubmit={handleSubmit}>
        {error && <span className="form__error">{error}</span>}

        <div className="form__fields">
          {fields.map(field => {
            const FieldComponent = fieldComponentMap[field.type];

            if (!FieldComponent) {
              return null;
            }

            return (
              <FieldComponent
                key={field.code}
                field={field}
              />
            );
          })}
        </div>

        <div className="form__actions">
          <PrimaryButton full big loading={submitting} disabled={submitting}>
            <FormattedMessage id="section.form.submit"/>
          </PrimaryButton>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./components/constructedForm/ConstructedForm.js